function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 1.337c-4.777 0-8.663 3.886-8.663 8.663S5.223 18.663 10 18.663s8.663-3.886 8.663-8.663S14.777 1.337 10 1.337M10 20C4.487 20 0 15.514 0 10S4.487 0 10 0c5.514 0 10 4.486 10 10s-4.486 10-10 10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.017 9.244a.377.377 0 01-.369.384H7.311c-.271 0-.45-.295-.332-.55l1.617-3.51a.369.369 0 01.332-.219h4.72c.204 0 .37.172.37.384v3.511zm-.314 1.688h-1.188a.299.299 0 01-.29-.303c0-.167.13-.303.29-.303h1.188c.16 0 .291.136.291.303 0 .167-.13.303-.291.303zM14.945 4H8.113a.368.368 0 00-.333.218l-3.077 6.68a.399.399 0 00-.036.166v3.815c0 .59.459 1.068 1.026 1.068h8.595c.566 0 1.025-.478 1.025-1.068V4.384A.376.376 0 0014.945 4z"
}));
function SvgExteriorToggle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgExteriorToggle;